import cda from './cda'

export default [...cda]
